import { render, staticRenderFns } from "./CreateOffice.vue?vue&type=template&id=180dfcbc&scoped=true&"
import script from "./CreateOffice.vue?vue&type=script&lang=js&"
export * from "./CreateOffice.vue?vue&type=script&lang=js&"
import style0 from "./CreateOffice.vue?vue&type=style&index=0&id=180dfcbc&scoped=true&lang=css&"
import style1 from "./CreateOffice.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180dfcbc",
  null
  
)

export default component.exports